import { ASSETS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/assets_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import {
	REFRIGERANT_ASSETS_TC,
	REFRIGERANT_CHECK_OUT_APPLIANCES_TC,
	REFRIGERANT_EVENT_ASSET_PICKER,
} from '../utils/RefrigerantUtils';

// Dedicated target collection for sub-asset fetches across the app (Sub Assets
// tab, WO creation/edit forms). Keeps these reads from overwriting the default
// `state.assets.recordsIds` / pagination that other pages depend on.
export const SUB_ASSETS_TARGET_COLLECTION = 'subAssetsFetch';

// Isolated overview collection for the "Link Sub Asset" picker modal so its
// asset list / selections / active filters never clobber the assets index.
// The filter-OPTION dropdowns reuse the shared `assetsAdvancedFilters`
// collection (already registered across every entity reducer the filters read
// from — locations, areas, asset_types, etc.), so we don't register a new one.
export const LINK_SUB_ASSET_MODAL_TARGET_COLLECTION = 'linkSubAssetModal';

// Resolution target for the PM bulk asset upload, which turns a pasted/uploaded list of Asset IDs
// into OpenWrench asset ids. It needs its own collection for two reasons: the reads must not clobber
// the paging/filters of whatever list is behind the modal, and `read` buckets its takeLatest
// cancellation BY TARGET COLLECTION — a `null` name shares the global `__default__take_latest`
// bucket, so an unrelated asset search firing mid-upload would cancel the resolution.
export const PM_BULK_ASSET_UPLOAD_TARGET_COLLECTION = 'pmBulkAssetUploadResolve';

const initialState: any = standardInitialStateGenerator([
	'assetsIndex',
	'WORK_ORDER_FORM_ASSETS_AUTOCOMPLETE',
	'SUPPLIER_WORK_ORDER_FORM_ASSETS_AUTOCOMPLETE',
	'SERVICE_REQUEST_FORM_ASSETS_AUTOCOMPLETE',
	'locationAssociatedAssets',
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSETS_AUTOCOMPLETE',
	'METER_FORM_ASSETS_AUTOCOMPLETE',
	'plannedMaintenanceAdvancedFilters',
	'assetsDowntime',
	'readyForReplacement',
	'troubleshootingFormIndex',
	'purchaseOrderReceivedAssets',
	'invoicesAdvancedFilters',
	'bulkEditAssets',
	'workOrdersAdvancedFilters',
	'invoicesAdvancedFilters',
	'quotesAdvancedFilters',
	// The shared advanced-filter option collection. Registered in every OTHER entity reducer the
	// filters read from (locations, areas, regions, asset_types, asset_types_additional_fields,
	// depreciation_classes) but missing here, so any page offering the ASSET filter — the only one whose
	// options come out of this slice — threw "invalid target collection name" the moment its dropdown
	// rendered. The comments below already assumed it was here.
	'assetsAdvancedFilters',
	SUB_ASSETS_TARGET_COLLECTION,
	LINK_SUB_ASSET_MODAL_TARGET_COLLECTION,
	// Refrigerant Tracking ▸ Assets. Its own collection rather than `assetsIndex` because the two
	// lists carry different permanent scopes and must not clobber each other's filters or paging.
	// Its filter dropdowns reuse the shared `assetsAdvancedFilters` name, as the modal above does.
	REFRIGERANT_ASSETS_TC,
	REFRIGERANT_EVENT_ASSET_PICKER,
	// The check-out form's appliance lookup. Its own collection so resolving a work order's assets by
	// id cannot clobber `state.assets.recordsIds` / pagination that the index behind the modal depends
	// on — the same reason SUB_ASSETS_TARGET_COLLECTION exists.
	REFRIGERANT_CHECK_OUT_APPLIANCES_TC,
	PM_BULK_ASSET_UPLOAD_TARGET_COLLECTION,
]);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
